<template>
	<div class="icon">
		<component :is="getComponent" :alt="getAlt"></component>
	</div>
</template>

<script>

	import Email from '@/icons/email.svg';
	import Facebook from '@/icons/facebook.svg';
	import LinkedIn from '@/icons/linkedin.svg';
	import Pinterest from '@/icons/pinterest.svg';
	import Twitter from '@/icons/twitter.svg';

	import JustBrowsing from '@/icons/just-browsing.svg';
	import SeriousHunters from '@/icons/serious-hunters.svg';
	import GettingStarted from '@/icons/getting-started.svg';
	import JustPurchased from '@/icons/just-purchased.svg';
	import ArrowDown from '@/icons/arrow-down.svg';
	import ArrowRight from '@/icons/arrow-right.svg';
	import Info from '@/icons/info.svg';
	import RealtorLogo from '@/icons/realtor-logo.svg';

	export default {

 		components: {
			Email,
			Facebook,
			LinkedIn,
			Pinterest,
			Twitter,
			JustBrowsing,
			SeriousHunters,
			GettingStarted,
			JustPurchased,
			ArrowDown,
			ArrowRight,
			Info,
			RealtorLogo,
		},

		props: {
			icon: {
				type: String,
				default: ''
			}
		},

		computed: {

			getComponent: function() {
				return this.icon;
			},

			getAlt: function() {
				var iconName = this.icon.toLowerCase();
				return this._translate('ui.icons.svg.' + iconName);
			}

		}

	}

</script>